export default {
    name: 'racks',
    component: () => import(/* webpackChunkName: "racks-layout" */ '@/modules/racks/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.racks.index',
            component: () => import(/* webpackChunkName: "racks-index" */ '@/modules/racks/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.racks.create',
            component: () => import(/* webpackChunkName: "racks-create" */ '@/modules/racks/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.racks.edit',
            component: () => import(/* webpackChunkName: "racks-edit" */ '@/modules/racks/views/Edit'),
        },
    ]
}